<template>
    <html>
    <body style="position: relative;background: #fff">
        <section class="section">
            <img src="@/assets/styles/images-link/ban8.png" alt="">
        </section>
        <section class="section container03">
        <div class="da">
            <div class="zuo">
            <h2>系统介绍</h2>
            <h4>SYSTEM INTRODUCTION</h4>
            <p>平台将利用GIS地理信息技术、视频监测、大数据等技术，推进果园监管信息化建设，加强对果园的土壤质量、肥料肥效、农资等内容的监测，通过建设果业大数据平台，实时反映果业生产、加工、流通、价格信息，为科学决策管理提供支持。</p>
            </div>
            <img src="@/assets/styles/images-link/g1.png" alt=""> </div>
        </section>
        <section class="section container03">
        <div class="da">
            <div class="zuo">
            <h2>大数据综合展示子系统</h2>
            <h4>Big Data Comprehensive Display Subsystem</h4>
            <p>通过果业各项数据指标，结合GIS地理信息系统将各地区果业基础数据、果品市场行情、数字果园、果品质量追溯、果品病虫害等信息进行图表分析，达到优化农业资源的分配和利用的目的。 </p>
            </div>
            <img src="@/assets/styles/images-link/g3.png" alt="" style="margin-top: -40px"> </div>
        </section>
        <section class="section container03 background1">
        <div class="da">
            <div class="zuo">
            <h2 style="color: #39bf3e">果品质量安全追溯系统 </h2>
            <h4>Fruit Quality Safety Traceability System</h4>
            <p style="font-size: 16px;line-height: 30px;color: #333">果品质量安全溯源系统是面向政府农业监管部门，根据果品原产地、生产、加工等农业关键环节进行构建，便于政府部门进行全程质量监管。</p>
            </div>
            <img src="@/assets/styles/images-link/g4.png" alt=""> </div>
        </section>
        <section class="section container13">
        <div class="da"> <img src="@/assets/styles/images-link/g5.png" alt="" class="you" style="width: 50%;">
            <div class="zuo" style="width: 50%;">
            <h2 style="color: #39bf3e">种植园区手机app</h2>
            <h4 style="color: #999">Planting park mobile app</h4>
            <p >方便用户在不受地域限制，时间限制的情况下进行数据查询及数据采集。主要包括相关资讯的查看、园区、种植户上报信息、果品质量安全追溯等功能。</p>
            </div>
        </div>
        </section>
    </body>
</html>
</template>

<style scoped>
    .background1{
        background: url('~@/assets/styles/images-link/bg15.png') center no-repeat;
        background-size: 100%
    }
</style>
<script>

    import '@/assets/styles/css/zhihui1.css';   
    export default {
        name: '',
        components: {},
        data: () => {
            return {

            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '种植业单品大数据系统 - ' + title[1];
        },

        methods: {

        },
    }
</script>
